import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useObserver} from "mobx-react-lite";
import {MenuItem, Icon} from "@/components";
import {Picker} from "antd-mobile";
import 'antd-mobile/lib/picker/style/css';
import {useStores} from "@/store";
import "./index.less";
/**Popular */
const Popular = ({menus,tap}) => {
    if (!menus.length) return null;
    const {t} = useTranslation();
    const {restaurantStore} = useStores();
    const [selectTimeAndDiscountData, setSelectTimeAndDiscountData] = useState([]);//Event
    const [popular, setPopular] = useState([]);// Popular
    const [saveNormalIconVisible, setSaveNormalIconVisible] = useState(false);// saveNormalIconVisible
    const [saveIconVisible, setSaveIconVisible] = useState(false);// saveIconVisible
    const [canceIconVisible, setCancelIconVisible] = useState(false);// canceIconVisible
    const [timeDiscount, setTimeDiscount] = useState(false);// canceIconVisible
    const [regionCountry, setRegionCountryData] = useState([]);//Event
    const data = [];
    let nowDate = new Date();
    let year = nowDate.getFullYear();
    let month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1)
      : nowDate.getMonth() + 1;
    let day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate
      .getDate();
    let dateStr = year + "-" + month + "-" + day;

    function getFront(mainStr,searchStr){
        let foundOffset=mainStr.indexOf(searchStr);
        if(foundOffset==-1){
            return null;
        }
        return mainStr.substring(0,foundOffset);
    }

//提取查找字符串后面的所有字符
    function getEnd(mainStr,searchStr){
        let foundOffset=mainStr.indexOf(searchStr);
        if(foundOffset==-1){
            return null;
        }
        return mainStr.substring(foundOffset+searchStr.length,mainStr.length);
    }

//在字符串 searchStr 前面插入字符串 insertStr
    function insertString(mainStr,searchStr,insertStr){
        var front=getFront(mainStr,searchStr);
        var end=getEnd(mainStr,searchStr);
        if(front!=null && end!=null){
            return front+insertStr+searchStr+end;
        }
        return null;
    }

    useEffect(() => {
        restaurantStore.getRestaurant().then((data2) => {
            restaurantStore.getSelectTimeAndDiscountData().then(function (data1) {
                if (null != data1) {
                    let tempData = data1.data;
                    if (undefined != tempData && null != tempData) {
                        for (let i = 0; i < tempData.length; i++) {
                            let todayData = tempData[i];
                            //dateStr
                            if (dateStr == todayData.date) {
                                let times = todayData.times;
                                for (let j = 0; j < times.length; j++) {
                                    let time = times[j]
                                    if (time.discount) {
                                        data.push({
                                            label:
                                              (<div>
                                                  <span style={{...leftStyle}}>{t("RESERVATION_TIME")}:{time.time}</span>
                                                  <span style={{...rightStyle}}>-{time.discount}</span>
                                              </div>),
                                            value: j + "-" + time.discount+"-"+time.time,
                                        })
                                    }
                                }
                            }
                        }
                    }
                    if(data.length>0){
                        setSaveNormalIconVisible(true);
                    }
                }
                setSelectTimeAndDiscountData(data)
            });//Select time & discount
            restaurantStore.getPopular().then(setPopular);//Select time & discount
            restaurantStore.getRegionCountry(data2.region.key_word).then(setRegionCountryData);//Select time & discount
        });

    }, []);
    const leftStyle = {
        width: '16px',
        height: '34px',
        marginLeft: '10px',
        float: 'left'
    };
    const rightStyle = {
        width: '16px',
        height: '34px',
        marginRight: '30px',
        float: 'right'
    };
    const [state, setState] = useState({
        selectValue: [''],
    });
    const onChangeSelect = (selectValue) => {
        let discount = selectValue[0].split("-")[1].substring(0, selectValue[0].split("-")[1].length - 1)
        setState({
            selectValue: selectValue,
        });
        setTimeDiscount(selectValue[0].split("-")[2]+" - "+discount+"%")
        restaurantStore.getPopulaCache(discount).then(setPopular);
        //set icon status
        setSaveNormalIconVisible(false)
        setSaveIconVisible(true)
        setCancelIconVisible(true)

    };
    function onCancel() {
        restaurantStore.getPopular().then(setPopular);
        setSaveNormalIconVisible(true)
        setSaveIconVisible(false)
        setCancelIconVisible(false)
        return;
    }
    return useObserver(() => {
        return (
            <section className="page-restaurant--Popular">
                <h3>{t("WEB.Full menu popular")} <span className="title-nums">{menus.length}</span></h3>
                <Picker
                    data={selectTimeAndDiscountData}
                    value={state.colorValue}
                    cols={1}
                    onChange={onChangeSelect}
                    okText={t("CONFIRM")}
                    dismissText={t("CANCEL")}
                    title={t("WEB.Select time & discount")}>
                    <div className="iconPopularDiv">
                        <div style={{display: saveNormalIconVisible ? "inline-block" : "none"}}>
                            <Icon icon={"icon icon-book_and_save_normal_colored"}/>
                        </div>
                    </div>
                </Picker>
                <div className="iconPopularDiv">
                    <div style={{display: canceIconVisible ? "inline-block" : "none",marginTop:"-5px"}}>
                        {t("RESERVATION_INFO.DISCOUNT")}{":"}{timeDiscount}
                    </div>
                    <div style={{display: saveIconVisible ? "inline-block" : "none"}}>
                        <Icon icon={"icon icon-save"}/>
                    </div>
                    <div style={{display: canceIconVisible ? "inline-block" : "none"}}  id={"cancel"} >
                        <Icon icon={"icon icon-cancel"} onClick={onCancel}/>
                    </div>
                </div>
                <div className="deals-list">
                    {popular.map((item, index) => {
                        return <MenuItem menu={item} key={item.id} odd={index % 2 === 0} index={index} mode={"popular"}/>;
                    })}
                </div>
                <div className="deal-description" dangerouslySetInnerHTML = {{ __html: regionCountry.vat_desc }}></div>
            </section>
        );
    });
};
export default Popular;
